export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13896.21f00a23.jpg";